<template>
  <v-app id="loginPage" :class="{ 'login-loading': get_interface.login_loading }">
    <v-content>
      <v-container fluid>
        <v-row align="center" justify="center" class="logo-row mt-5">
          <v-img
            src="../assets/logo-fios.png"
            lazy-src="../assets/logo-fios.png"
            aspect-ratio="1"
            max-width="750"
            max-height="250"
            class="login-logo"
          ></v-img>
        </v-row>
        <v-row align="center" justify="center" class="login-row mt-7">
          <v-col cols="12" sm="8" md="4" class="login-col">
            <v-card class="login-card elevation-12" :loading="get_interface.login_loading">
              <v-toolbar flat>
                <v-toolbar-title>{{ lang.login.signin }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="py-5 px-4">
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-text-field
                    v-model="login.login"
                    :rules="lang.login.rules.loginRules"
                    :label="lang.login.login"
                    :error="login_error"
                    @keyup.enter.native="userLogin"
                    type="text"
                    id="login"
                    name="login"
                    prepend-icon="mdi-account"
                  />

                  <v-text-field
                    v-model="login.password"
                    :rules="lang.login.rules.passwordRules"
                    :label="lang.login.password"
                    :error="login_error"
                    :error-messages="error_message"
                    @keyup.enter.native="userLogin"
                    type="password"
                    id="password"
                    name="password"
                    prepend-icon="mdi-key-variant"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions class="pa-4">
                <v-spacer />
                <v-btn
                  @click="userLogin"
                  :loading="get_interface.login_loading"
                  :disabled="(get_interface.login_loading || (login.login.length === 0 || login.password.length === 0))"
                  color="primary"
                >
                  {{ lang.login.signin }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="dev-row">
          <a
            href="https://www.solarisweb.com.br"
            target="_blank"
            class="dev-logos"
          >
            <v-img
              src="../assets/sun_2020.png"
              lazy-src="../assets/sun_2020.png"
              aspect-ratio="1"
              width="77"
              class="dev-logo"
            />
            <div class="logo"></div>
          </a>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    source: String
  },
  data: () => ({
    valid: true,
    login_error: false,
    error_message: null,
    login: {
      login: '',
      password: ''
    }
  }),
  methods: {
    userLogin () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('userLogin', { login: this.login.login, password: this.login.password })
      }
    }
  }
}
</script>

<style lang="scss">
#loginPage {
  font-family: "Open Sans", sans-serif !important;
  background: #f2f2f2;
  &.login-loading {
    background-image: linear-gradient(
      -90deg,
      hsl(314, 85%, 75%),
      hsl(269, 85%, 75%),
      hsl(224, 85%, 75%),
      hsl(89, 85%, 75%),
      hsl(55, 85%, 75%),
      hsl(29, 85%, 75%),
      hsl(359, 85%, 75%),
      hsl(314, 85%, 75%),
    ) !important;
    background-size: 200% 200% !important;
    animation: chroma 3s linear infinite !important;
  }
  .logo-row {
    .login-logo {
      max-height: 250px;
      max-width: 750px;
      width: 100% !important;
      .v-image__image {
        background-size: contain !important;
      }
    }
  }
  .login-row {
    .login-col {
      .login-card {
        box-shadow: 0px 0px 9px -1px rgb(0 0 0 / 30%) !important;
        border-radius: 7px !important;
        overflow: hidden;
        .v-toolbar {
          .v-toolbar__content {
            background-color: #f2f2f2 !important;
            border-top-left-radius: 5px !important;
            border-top-right-radius: 5px !important;
            .v-toolbar__title {
              color: #777;
            }
          }
        }
        .v-text-field {
          max-height: 75px !important;
        }
      }
    }
  }
  .dev-row {
    .dev-logos {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      max-width: 124px;
      margin: 33px auto;
      * {
        width: 100%;
        text-align: center;
      }
      .logo {
        width: 124px;
        height: 17px;
        margin: 7px auto;
        z-index: 196 !important;
        background: linear-gradient(
          -90deg,
          hsl(314, 85%, 59%),
          hsl(269, 85%, 59%),
          hsl(224, 85%, 59%),
          hsl(89, 85%, 59%),
          hsl(55, 85%, 59%),
          hsl(29, 85%, 59%),
          hsl(359, 85%, 59%),
          hsl(314, 85%, 59%)
        );
        background-size: 110% 100%;
        -webkit-mask-image: url('../assets/works.svg');
        -webkit-mask-size: 100%;
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-position: center;
        animation: chroma_test 2000ms linear;
        filter: brightness(120%), drop-shadow(1px 1px 4px rgba(0,0,0,0.4)) !important;
      }
      .dev-logo {
        max-width: 37px;
        margin: 3px auto;
      }
    }
  }
}

@keyframes chroma {
  0%{background-position: 200% 200% ;}
  100%{background-position: 0% 0% ;}
 }

@keyframes chroma_test {
  0% { background-position: 1250% 0; }
  100% { background-position: 0 0; }
}
</style>
